import React, { ReactNode } from 'react';

import {
  CmCheckBox,
  CmTable,
  CmTableHeader,
  CmTbody,
  CmTh,
  CmTooltip,
  QuestionIcon,
} from '@/components/uiParts';

type Props = {
  isMultipleCheck?: boolean;
  isSelectAll?: boolean;
  ths: {
    minWidth: string;
    label: string;
    question?: string;
  }[];
  handleMultipleCheck?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  children: ReactNode;
};

export const CmBaseTableWithQuestionIcon: React.FC<Props> = ({
  isMultipleCheck = false,
  isSelectAll = false,
  ths,
  handleMultipleCheck,
  children,
}) => {
  return (
    <CmTable>
      <CmTableHeader>
        {isMultipleCheck && (
          <CmTh left="0" zIndex="2">
            <CmCheckBox
              isChecked={isSelectAll}
              size="lg"
              onChange={handleMultipleCheck}
            />
          </CmTh>
        )}
        {ths.map((th) => (
          <CmTh key={th.label} minWidth={th.minWidth}>
            {th.label}
            {th.question && (
              <CmTooltip label={th.question}>
                <QuestionIcon
                  color="gray"
                  size="sm"
                  verticalAlign="text-top"
                  marginLeft="2px"
                  fontSize="small"
                />
              </CmTooltip>
            )}
          </CmTh>
        ))}
      </CmTableHeader>
      <CmTbody>{children}</CmTbody>
    </CmTable>
  );
};
